import { createUseStyles } from 'react-jss';

export const addGpcEquipmentStyles = createUseStyles({
  container: {

  },
});
